import {ListItemIcon, ListItemText, Menu, MenuItem, Tooltip} from "@mui/material";
import React from "react";
import {useStores} from "../../../../../../stores";
import {Cancel, FilterAlt, FilterAltOff, FilterListAlt} from "@mui/icons-material";
import {MatPartReviewRowState} from "../../../../../../services/classes/MaterializedClasses.ts";
import {ToolbarButton} from "@mui/x-data-grid";
import {CAT_EQ_OPERATOR, CAT_NEQ_OPERATOR} from "../filters/CategoryFilter.tsx";

export const ToolbarQuickFilters: React.FC = () => {
    const {categorizationReviewStore} = useStores()
    const filterController = categorizationReviewStore.reviewPageController.reviewPageFilterController;

    const [open, setOpen] = React.useState(false);
    const ref = React.useRef<HTMLButtonElement>(null);

    const notReviewedActive = filterController.hasFilter('state', 'isAnyOf', [MatPartReviewRowState.input, MatPartReviewRowState.ai])
    const onlyReviewedActive = filterController.hasFilter('state', 'is', MatPartReviewRowState.reviewed)

    return <>
        <Tooltip title="Quick filters">
            <ToolbarButton
                id="toolbar-quick-filters-button"
                ref={ref}
                onClick={() => setOpen(true)}>
                <FilterListAlt fontSize="small"/>
            </ToolbarButton>
        </Tooltip>
        <Menu
            id="toolbar-quick-filters-menu"
            anchorEl={ref.current}
            open={open}
            onClose={() => setOpen(false)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}>
            <MenuItem onClick={() => {
                filterController.toggleFilter('state', 'isAnyOf', [MatPartReviewRowState.input, MatPartReviewRowState.ai]);
                setOpen(false);
            }}>
                <ListItemIcon>
                    {notReviewedActive
                        ? <FilterAlt fontSize="small" color="primary"/>
                        : <FilterAltOff fontSize="small"/>
                    }
                </ListItemIcon>
                <ListItemText>Not reviewed</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => {
                filterController.toggleFilter('state', 'is', MatPartReviewRowState.reviewed);
                setOpen(false);
            }}>
                <ListItemIcon>
                    {onlyReviewedActive
                        ? <FilterAlt fontSize="small" color="primary"/>
                        : <FilterAltOff fontSize="small"/>
                    }
                </ListItemIcon>
                <ListItemText>Only reviewed</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => {
                filterController.toggleCatNotEqualsPrevFilter();
                setOpen(false);
            }}>
                <ListItemIcon>
                    {filterController.catNotEqualPrevFilterIsActive
                        ? <FilterAlt fontSize="small" color="primary"/>
                        : <FilterAltOff fontSize="small"/>
                    }
                </ListItemIcon>
                <ListItemText>{CAT_NEQ_OPERATOR.label}</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => {
                filterController.toggleCatEqualsPrevFilter();
                setOpen(false);
            }}>
                <ListItemIcon>
                    {filterController.catEqualPrevFilterIsActive
                        ? <FilterAlt fontSize="small" color="primary"/>
                        : <FilterAltOff fontSize="small"/>
                    }
                </ListItemIcon>
                <ListItemText>{CAT_EQ_OPERATOR.label}</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => {
                filterController.clearFilters();
                setOpen(false);
            }}>
                <ListItemIcon>
                    <Cancel fontSize="small"/>
                </ListItemIcon>
                <ListItemText>Clear</ListItemText>
                {/*<Typography variant="body2" sx={{color: 'text.secondary'}}>*/}
                {/*    <Cancel fontSize="small"/>*/}
                {/*</Typography>*/}
            </MenuItem>
        </Menu>
    </>
}